import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import { uil_can_undo } from '../../ui_logic';
import BarButton from '@components/bar-button';
import { enable_force_refresh } from '../../state/force-refresh';
import undo_svg from '../../../assets/img/SVG_icons/Left/main_control/undo.svg';
import { img } from '@phi/components';
import { uid_undo } from '../../ui_display';
import UndoTooltip from './UndoTooltip';

export const UndoIcon = undo_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded || this.state.tut_stage < 1;
        },

        alt() {
            return 'Undo';
        },

        disabled() {
            if (this.coming_soon)
                return true;
            else {
                enable_force_refresh();
                return !uil_can_undo();
            }
        },

        selected() {
            return this.state.tut_stage === 1;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else
                uid_undo();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            selected: this.selected,
            id: 'undo-button',
            wrapperId: 'undo-button-wrapper',
            tippy: 'right',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(undo_svg, this.alt),
            tooltip: UndoTooltip,
        });
    },
});
